import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { verifyPasskey } from '../api/client.js';

import type { PartySlug, VerifyPasskeyResponse } from '@mixwire/contracts';

type VerifyVariables = { readonly slug: PartySlug; readonly passkey: string };

export const useVerifyPasskey = (): UseMutationResult<
  VerifyPasskeyResponse,
  Error,
  VerifyVariables
> =>
  useMutation({
    mutationFn: async ({ slug, passkey }: VerifyVariables) => verifyPasskey(slug, passkey),
  });
